import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import Link from '../Link'
import Button from '../Button/'
import {
  darkClass,
  containerClass,
  blockSubtitleClass,
  cardsContainerClass,
  cardClass,
  cardImageClass,
  ctaClass,
} from './index.module.css'
import ArrowRight from '../../../assets/images/ArrowRight.svg'

const ContentCards = ({
  title,
  subtitle,
  components,
  backgroundColor,
  isDarkTheme,
}) => {
  return (
    <div
      style={{ backgroundColor: backgroundColor }}
      className={isDarkTheme ? darkClass : ''}
    >
      <div className={containerClass}>
        {title && <h2>{title}</h2>}

        {subtitle?.subtitle && (
          <p className={blockSubtitleClass}>{subtitle.subtitle}</p>
        )}

        <div className={cardsContainerClass}>
          {components &&
            components.map((component, idx) => {
              return (
                <div className={cardClass} key={idx}>
                  {component.image && component.ctaUrl && (
                    <Link to={component.ctaUrl}>
                      <GatsbyImage
                        image={component.image.gatsbyImageData}
                        className={cardImageClass}
                      />
                    </Link>
                  )}
                  {component.image && !component.ctaUrl && (
                    <GatsbyImage
                      image={component.image.gatsbyImageData}
                      className={cardImageClass}
                    />
                  )}
                  {component.superHeader && component.ctaUrl && (
                    <Link to={component.ctaUrl}>
                      <div className="small">{component.superHeader}</div>
                    </Link>
                  )}
                  {component.superHeader && !component.ctaUrl && (
                    <div className="small">{component.superHeader}</div>
                  )}
                  {component.title && (
                    <h4>
                      {component.ctaUrl ? (
                        <Link to={component.ctaUrl}>{component.title}</Link>
                      ) : (
                        component.title
                      )}
                    </h4>
                  )}

                  {component.subtitle?.subtitle && (
                    <p>{component.subtitle.subtitle}</p>
                  )}

                  {component.ctaUrl && component.ctaText && (
                    <Link to={component.ctaUrl} className={ctaClass}>
                      {component.ctaDefaultDisplay !== false ? (
                        <Button>{component.ctaText}</Button>
                      ) : (
                        <>
                          <span>{component.ctaText}</span>
                          <ArrowRight />
                        </>
                      )}
                    </Link>
                  )}
                </div>
              )
            })}
        </div>
      </div>
    </div>
  )
}

export default ContentCards
